import { IconLookup } from 'component-library-and-tools';

export const DISABLE_OPTION = { name: 'disable', icon: IconLookup.PROHIBITED };
export const ENABLE_OPTION = { name: 'enable', icon: IconLookup.PLAY };
export const EDIT_OPTION = { name: 'edit', icon: IconLookup.PENCIL2 };
export const DELETE_OPTION = { name: 'delete', icon: IconLookup.TRASH };

const COMMON_WORKFLOW_CONTEXTUAL_MENU_OPTIONS = [
  EDIT_OPTION,
  DELETE_OPTION,
];

export const DISABLED_WORKFLOW_CONTEXTUAL_MENU_OPTIONS = [
  // ENABLE_OPTION,
  ...COMMON_WORKFLOW_CONTEXTUAL_MENU_OPTIONS,
];

export const NON_DISABLED_WORKFLOW_CONTEXTUAL_MENU_OPTIONS = [
  // DISABLE_OPTION,
  ...COMMON_WORKFLOW_CONTEXTUAL_MENU_OPTIONS,
];
